import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/auth/layout.tsx");
